import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { PropertyTypeListRequestBody, PropertyTypeListResponse } from "./types";

export class PropertyTypeListAPI extends BaseAPI<
    PropertyTypeListRequestBody,
    PropertyTypeListResponse
> {
    protected route = ApiRoutes.property.type;
    protected method = RequestMethod.GET;
}
